export const retryAsyncFunction = async (asyncFn, maxRetries, onFailure) => {
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
            return await asyncFn() // Attempt the async function
        } catch (err) {
            if (attempt === maxRetries) {
                onFailure(err) // Handle failure after final attempt
            }
        }
    }
}
